var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
let PoiPopup = class PoiPopup extends LitElement {
    constructor() {
        super(...arguments);
        this.poi = null;
        this.logoUrl = null;
    }
    render() {
        if (!this.poi)
            return html ``;
        const { name, description, address, postal_code, city, created_at, updated_at, } = this.poi;
        return html `
      <div class="card">
        <div class="header">
          <div class="header-text">
            <h3>${name}</h3>
          </div>
          ${this.logoUrl ? html `<img class="logo" src="${this.logoUrl}" alt=${msg('Logo', { id: 'poi.popup.logoAlt', desc: 'Alt text for POI logo image' })} />` : ''}
        </div>

        ${description
            ? html `<div class="description">${description}</div>`
            : ''}

        <div class="section">
          <div class="label">${msg('Address', { id: 'poi.popup.address', desc: 'Address label in popup' })}</div>
          <div class="value">${address ?? 'N/A'}</div>
          <div class="value">${postal_code ?? ''} ${city ?? ''}</div>
        </div>

        <div class="buttons">
          <simple-button variant="secondary" @button-click=${this._onEdit} label=${CommonActions.edit()}></simple-button>
          <simple-button variant="danger" @button-click=${this._onDelete} label=${CommonActions.delete()}></simple-button>
        </div>

        <div class="meta">
          <div>${msg('Created on:', { id: 'poi.popup.createdOn', desc: 'Created date label' })} ${new Date(created_at).toLocaleString()}</div>
          <div>${msg('Updated on:', { id: 'poi.popup.updatedOn', desc: 'Updated date label' })} ${new Date(updated_at).toLocaleString()}</div>
        </div>
      </div>
    `;
    }
    _onEdit() {
        this.dispatchEvent(new CustomEvent('edit-poi', { detail: { selectedPoi: this.poi } }));
    }
    _onDelete() {
        this.dispatchEvent(new CustomEvent('delete-poi', { detail: this.poi }));
    }
};
PoiPopup.styles = css `
    :host {
      display: block;
      font-family: inherit;
      font-size: 14px;
      color: #1a1a1a;
      padding: 0;
      max-width: 300px;
    }

    .card {
      padding: 4px 6px;
    }

    .header {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 8px;
    }

    .header-text {
      flex: 0 0 66%;
      min-width: 0;
    }

    .logo {
      flex: 0 0 33%;
      max-width: 33%;
      height: 48px;
      object-fit: contain;
      border-radius: 4px;
    }

    h3 {
      margin: 0;
      font-size: 17px;
      font-weight: 600;
      color: #111;
    }

    h3::first-letter {
      text-transform: uppercase;
    }

    .description {
      font-size: 14px;
      margin: 8px 0 12px;
      color: #444;
      line-height: 1.4;
    }

    .section {
      margin-bottom: 10px;
    }

    .label {
      font-weight: 600;
      font-size: 13px;
      margin-bottom: 2px;
      color: #555;
    }

    .value {
      background: #f7f7f7;
      padding: 6px 8px;
      border-radius: 6px;
      font-size: 13px;
      color: #333;
    }

    .coords {
      display: flex;
      gap: 6px;
    }

    .buttons {
        display: flex;
        gap: 10px;
        margin-top: 14px;
    }

        simple-button {
        flex: 1;      /* ⬅ makes each button grow to full width of row */
        width: 100%;
    }

    .meta {
      margin-top: 14px;
      font-size: 11px;
      color: #888;
      border-top: 1px solid #eee;
      padding-top: 10px;
      line-height: 1.3;
    }
  `;
__decorate([
    property({ type: Object })
], PoiPopup.prototype, "poi", void 0);
__decorate([
    property({ type: String })
], PoiPopup.prototype, "logoUrl", void 0);
PoiPopup = __decorate([
    localized(),
    customElement('poi-popup')
], PoiPopup);
export { PoiPopup };
//# sourceMappingURL=PoiPopup.js.map